import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import { PATH } from './const/path';
import { LayoutDataService } from './layout-data.service';
import { NavbarComponent } from './core/navbar/navbar.component';
import { FlashMessageComponent } from './core/flash-message/flash-message.component';
import { HttpErrorComponent } from './core/http-error/http-error.component';
import { LoadingWidgetDirective } from './core/directives/loading-widget/loading-widget.directive';

@Component({
    selector: 'admin-layout',
    templateUrl: './layout.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, NgClass, NavbarComponent, FlashMessageComponent, HttpErrorComponent, LoadingWidgetDirective]
})
export class LayoutComponent implements OnInit, OnDestroy {

  clazz: string;
  shown = false;
  showNavigationBar = true;
  message: { [key: string]: string } = {};
  
  private subscription$: Subscription = new Subscription();
  private readonly notification$: Subscription = new Subscription();

  constructor(private readonly layoutDataService: LayoutDataService) { }

  ngOnInit(): void {
    const path = sessionStorage.getItem('adminUIPath');
    if (path?.includes(PATH.tasks)) {
      this.showNavigationBar = false;
    } else {
      this.showNavigationBar = true;
    }
    this.subscription$ = this.layoutDataService.path$
      .subscribe(value => {
        if (value) {
          if (value.includes(PATH.user)) {
            this.clazz = 'user-context';
          } else {
            this.clazz = null;
          }
        }
      });
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
    this.notification$.unsubscribe();
  }

}
